import React from "react"
import { Link } from "gatsby"
import Logo from "../../assets/kaden-logo.inline.svg"
import SiteSwitcher from "./switchoptions"
class Footer extends React.Component {
  render() {
    const company = [
      {
        label: "About",
        path: "/about-kaden/",
      },
      {
        label: "Where to buy",
        path: "/where-to-buy/",
      },
    ]

    const support = [
      /*{
        label: "FAQs",
        path: "/faqs/",
      },
      {
        label: "Request an installer",
        path: "/request-an-installer/",
      },*/
      {
        label: "Contact us",
        path: "/contact-us/",
      },
    ]

    const products = this.props.prods

    const footer = (
      <div id="footer" className="footer-wrap">
        <div className="uk-background-primary uk-section uk-padding-remove-horizontal uk-light">
          <div className="uk-container">
            <div className="uk-flex uk-flex-between uk-flex-wrap">
              <div className="uk-width-1-2 uk-width-auto@m uk-margin-bottom uk-margin-medium-right@m">
                <Link to="/" className="logo-link" activeClassName="uk-active">
                  <Logo className="logo logo--white" />
                </Link>
                <SiteSwitcher/>
              </div>
              <div className="uk-width-1-2 uk-hidden@m uk-margin-bottom">
                <ul
                  className="uk-list"
                  uk-scrollspy-nav="closest: li; scroll: true; cls: nah;"
                >
                  <li className="uk-text-right">
                    <a href="#top">
                      <span
                        className="uk-margin-small-right"
                        uk-icon="icon: arrow-up; ratio: 1"
                      ></span>
                      Back to top
                    </a>
                  </li>
                </ul>
              </div>
              <div className="uk-width-1-1 uk-width-auto@m uk-margin-bottom uk-margin-right@m">
                <h5 className="uk-text-p-large uk-text-bold uk-margin-small">
                  Products
                </h5>
                <ul className="uk-list uk-margin-small-top">
                  {products.map((item, i) => (
                    <li key={i}>
                      <Link
                        to={item.path}
                        activeClassName="uk-active"
                        dangerouslySetInnerHTML={{ __html: item.label }}
                      />
                    </li>
                  ))}
                </ul>
              </div>
              <div className="uk-width-1-2 uk-width-auto@m uk-margin-bottom uk-margin-medium-right@m">
                <h5 className="uk-text-p-large uk-text-bold uk-margin-small">
                  Company
                </h5>
                <ul className="uk-list uk-margin-small-top">
                  {company.map((item) => (
                    <li key={item.path}>
                      <Link
                        to={item.path}
                        activeClassName="uk-active"
                        dangerouslySetInnerHTML={{ __html: item.label }}
                      />
                    </li>
                  ))}
                </ul>
              </div>
              <div className="uk-width-1-2 uk-width-auto@m uk-margin-bottom uk-margin-medium-right@m">
                <h5 className="uk-text-p-large uk-text-bold uk-margin-small">
                  Support
                </h5>
                <ul className="uk-list uk-margin-small-top">
                  {support.map((item, i) => (
                    <li key={item.path}>
                      <Link
                        to={item.path}
                        activeClassName="uk-active"
                        dangerouslySetInnerHTML={{ __html: item.label }}
                      />
                    </li>
                  ))}
                </ul>
              </div>
              {/*<div className="uk-visible@m uk-margin-right">
                <h5 className="uk-text-p-large uk-text-bold">
                  We've got you covered
                </h5>
                <Link
                  to="/request-an-installer/"
                  className="uk-button uk-button-default uk-border-pill"
                >
                  Request an installer
                </Link>
              </div>*/}
              <div className="uk-width-1-1 uk-width-auto@m uk-visible@m uk-width-1-4@l uk-text-center">
                <ul
                  className="uk-list"
                  uk-scrollspy-nav="closest: li; scroll: true; cls: nah;"
                >
                  <li>
                    <a href="#top">
                      <span
                        className="uk-margin-small-right"
                        uk-icon="icon: arrow-up; ratio: 1"
                      ></span>
                      Back to top
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="uk-padding-xsmall uk-text-primary uk-section-primary-light">
          <div className="uk-container">
            <div className="uk-flex uk-flex-between uk-flex-middle uk-flex-wrap uk-text-small">
              <div className="uk-margin-small-bottom">
                <a
                  href="/kaden-website-terms-of-access.pdf"
                  className="uk-margin-small-right uk-margin-left@m"
                  target="_blank"
                >
                  Terms &amp; Conditions
                </a>

                <Link
                  to="/privacy-policy"
                  className="uk-margin-small-right uk-margin-left@m"
                  activeClassName="uk-active"
                >
                  Privacy Policy
                </Link>
              </div>
              <div className="uk-flex uk-flex-middle uk-flex-between uk-width-1-1 uk-width-auto@m uk-margin-small-bottom">
                <div className="uk-flex-last@m">
                  &copy; Kaden {new Date().getFullYear()}
                </div>
                {/*<div className="uk-flex-first@m">
                  <a
                    href="https://www.instagram.com/kaden.air/"
                    target="_blank"
                    className="uk-margin-small-right"
                    uk-icon="icon: instagram; ratio: 0.9;"
                  ></a>
                  <a
                    href="https://www.facebook.com/KadenAir/"
                    target="_blank"
                    className="uk-margin-small-right"
                    uk-icon="icon: facebook; ratio: 0.9;"
                  ></a>
                </div>*/}
              </div>
            </div>
          </div>
        </div>
      </div>
    )

    return footer
  }
}

export default Footer
